import React from 'react';
import "./community.css";
import Footer from "./footer";
function Community() {
    return (
        <div className="communities">
           <h1>No community now !!keep tuned🙂 </h1> 
        </div>

    )
}

export default Community
